export const LOGIN_MODE = {
  DEFAULT: 'DEFAULT',
  WITH_REDIRECT: 'WITH_REDIRECT'
};

export const HUB_CONNECTION_STATE = {
  CONNECTED: 'CONNECTED',
  DISCONNECTED: 'DISCONNECTED'
}



// WEBPACK FOOTER //
// ./src/const/paymentKiosk.js